import { VerticalTranslationContext } from './Contexts';
import { useContext } from 'react';
export default function TranslatableGridRow({editable, rowRef, children, inDragRowState}){

  const verticalImageResizeTranslation = useContext(VerticalTranslationContext);

  let rowTranslation = editable!== false ? verticalImageResizeTranslation.y : 0;

  return (
    <tr 
      class="grid-row" 
      ref={rowRef} 
        style={{
          //pointerEvents:(inDragRowState?'none':'unset'),
          position:'relative',
          transform:'translate(0,'+rowTranslation+'px)'}}>
      {children}
    </tr>
  )

}
